import MuiToggleButton from '@mui/material/ToggleButton';
import Button from '../Button/Button';

const ToggleButton = (props) => {
  // quick hack to check for icon only button
  const isIconButton = typeof props.children === 'object';
  return (
    <MuiToggleButton
      sx={
        isIconButton && {
          px: '10px',
          '&.Mui-selected': {
            px: '10px',
          },
        }
      }
      component={Button}
      color="secondary"
      variant="outlined"
      {...props}
    />
  );
};

export default ToggleButton;
